import { Typography } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

export const NumbersWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '6px',
})

export const NumberBox = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '4px',
  border: `1px solid ${theme.colors.violet[500]}`,
  backgroundColor: theme.colors.sky[50],
  width: '36px',
  height: '28px',
}))

export const NumberText = styled(Typography)(({ theme }) => ({
  color: theme.colors.dark,
  fontSize: '1rem',
  fontWeight: 700,
  lineHeight: 1.2,
}))
